import { gql } from "@apollo/client";

export const SAVE_REQUISITO_CLIENTES = gql`
    mutation saveRequisitoCliente(
        $input: AddRequisitoClienteInput!
    ){
        saveRequisitoCliente(input: $input){
            idRequisitoCliente
        }
    }
`;

export const saveRequisitoClienteAdapter = (requisitoCliente, REQUISITOS) => {
  const { nombre, codSap, __typename, oficinaVentas, cuit, ...reqCliente } = requisitoCliente;
  return {
    ...reqCliente,
    idTmpFact: parseInt(reqCliente.idTmpFact),
    presentacionFact: parseInt(reqCliente.presentacionFact),
    docRespaldatoria: parseInt(reqCliente.docRespaldatoria),
    idTipoAutorizacion: parseInt(reqCliente.idTipoAutorizacion),
    cod_Sap: codSap,
    t_RequisitoTipoModulo: reqCliente.t_RequisitoTipoModulo != null ? reqCliente.t_RequisitoTipoModulo.filter((item) => {
      const requisito = REQUISITOS.find((req) => req.id === item.idRequisito);
      return requisito && reqCliente[requisito.name] !== 0;
    }) : []
  };
};